import { render, staticRenderFns } from "./ProjectInfo_comp.vue?vue&type=template&id=24f5be99&scoped=true&"
import script from "./ProjectInfo_comp.vue?vue&type=script&lang=js&"
export * from "./ProjectInfo_comp.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInfo_comp.vue?vue&type=style&index=0&id=24f5be99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f5be99",
  null
  
)

export default component.exports